type WarehouseAddressCardProps = {
  title: string;
  name: string;
  addressLines: string[];
  mapHref?: string;
};

export function WarehouseAddressCard({
  title,
  name,
  addressLines,
  mapHref,
}: WarehouseAddressCardProps) {
  const content = (
    <div className="rounded-2xl border-2 border-dashed border-blue-300 bg-blue-50 p-6 text-center">
      <h3 className="mb-2 text-xs font-bold uppercase tracking-widest text-blue-500">
        {title}
      </h3>
      <p className="text-lg font-bold text-gray-900">{name}</p>
      <p className="leading-relaxed text-gray-600">
        {addressLines.map((line, index) => (
          <span key={`${line}-${index}`}>
            {line}
            {index < addressLines.length - 1 && <br />}
          </span>
        ))}
      </p>
    </div>
  );

  if (!mapHref) {
    return content;
  }

  return (
    <a href={mapHref} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  );
}
